import { createGlobalState } from 'react-hooks-global-state';
const { useGlobalState } = createGlobalState({ search: '', resourceType: '' });

export default useGlobalState;
